// Constantes de ordenação
export const SORT_FIELD = {
  ASSOCIATED_AT: "associatedAt",
  PRINTED_AT: "printedAt",
  CREDENTIAL_TYPE: "credentialType",
  CREDENTIAL_NAME: "credentialName",
  COLLABORATOR_NAME: "collaboratorName",
  DOCUMENT: "document",
  ASSIGNMENT: "assignment",
  COMPANY_NAME: "companyName",
  WITHDRAWN_AT: "withdrawnAt",
  NAME_OF_SIGNATURE: "nameOfSignature",
  PROTOCOL: "protocol",
};

export const SORT_ORDER = {
  ASC: "asc",
  DESC: "desc",
};

// Ordenação padrão por aba, alinhada ao default aplicado pelo backend quando não há sortBy:
// Associadas -> data de associação; Impressas -> última impressão; Retiradas -> data de retirada.
// Sempre da mais recente para a mais antiga (DESC). A aba Disponíveis (1) não ordena.
export const DEFAULT_SORT = {
  1: { field: null, order: null },
  2: { field: SORT_FIELD.ASSOCIATED_AT, order: SORT_ORDER.DESC },
  3: { field: SORT_FIELD.PRINTED_AT, order: SORT_ORDER.DESC },
  4: { field: SORT_FIELD.WITHDRAWN_AT, order: SORT_ORDER.DESC },
};

// Campos ordenáveis por abas
export const SORTABLE_FIELDS_BY_TAB = {
  2: [
    SORT_FIELD.ASSOCIATED_AT,
    SORT_FIELD.CREDENTIAL_TYPE,
    SORT_FIELD.COLLABORATOR_NAME,
    SORT_FIELD.CREDENTIAL_NAME,
    SORT_FIELD.DOCUMENT,
    SORT_FIELD.ASSIGNMENT,
    SORT_FIELD.COMPANY_NAME,
  ],
  3: [
    SORT_FIELD.CREDENTIAL_TYPE,
    SORT_FIELD.COLLABORATOR_NAME,
    SORT_FIELD.CREDENTIAL_NAME,
    SORT_FIELD.DOCUMENT,
    SORT_FIELD.ASSIGNMENT,
    SORT_FIELD.COMPANY_NAME,
  ],
  4: [
    SORT_FIELD.WITHDRAWN_AT,
    SORT_FIELD.CREDENTIAL_TYPE,
    SORT_FIELD.CREDENTIAL_NAME,
    SORT_FIELD.DOCUMENT,
    SORT_FIELD.ASSIGNMENT,
    SORT_FIELD.COMPANY_NAME,
    SORT_FIELD.NAME_OF_SIGNATURE,
    SORT_FIELD.PROTOCOL,
  ],
};

// Storage key
export const SORT_STORAGE_KEY = "credentialsSort";

// Ordenação padrão da aba (fallback seguro quando a aba não está mapeada).
export const getDefaultSort = (tab) =>
  DEFAULT_SORT[tab] || { field: null, order: null };

// Persistência da ordenação por aba durante a sessão (sessionStorage).
// Mantém a última ordenação aplicada em cada aba ao navegar entre telas e voltar.
export const loadSort = (tab) => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(SORT_STORAGE_KEY) || "{}");
    return stored[tab] || getDefaultSort(tab);
  } catch (error) {
    return getDefaultSort(tab);
  }
};

export const saveSort = (tab, sortConfig) => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(SORT_STORAGE_KEY) || "{}");
    sessionStorage.setItem(
      SORT_STORAGE_KEY,
      JSON.stringify({ ...stored, [tab]: sortConfig }),
    );
  } catch (error) {
    // sessionStorage indisponível: segue sem persistir.
  }
};

// Converte a ordem interna (asc/desc) para o formato esperado pelo antd Table.
export const toAntdSortOrder = (order) => {
  if (order === SORT_ORDER.ASC) return "ascend";
  if (order === SORT_ORDER.DESC) return "descend";
  return null;
};
